<div class="flex flex-col">
  <!-- Browse brands -->
  <div class="flex flex-col gap-6 mb-8">
    <div class="flex items-center justify-between">
      <span class="text-[#222528] text-[1.1875rem] font-bold">{{ 'rewards.browseBrands' | translate }}</span>
      <span class="text-[#007DCB] text-[1rem] cursor-pointer" (click)="onViewAllBrands()">
        {{ 'rewards.viewAll' | translate }}
      </span>
    </div>
    @if (brandsIsLoading()) {
      <div class="relative min-h-[5rem] w-full">
        <korviu-loader></korviu-loader>
      </div>
    } @else {
      <div class="grid grid-cols-2 md:grid-cols-5 gap-x-4 gap-y-6">
        @for (brand of brands(); track brand.id) {
          <app-brand-card [image]="brand.image" [alt]="brand.name" (click)="onBrandClick(brand.id)" />
        }
      </div>
    }
  </div>

  <!-- Explore rewards -->
  <div class="flex flex-col gap-6">
    <div class="flex items-center justify-between">
      <span class="text-[#222528] text-[1.1875rem] font-bold">{{ 'rewards.exploreRewardsTitle' | translate }}</span>
    </div>
    @if (categoriesIsLoading()) {
      <korviu-loader />
    } @else {
      <app-category-carousel
        [categories]="categories()"
        [selectedCategoryId]="selectedCategoryId()"
        (categorySelected)="onCategoryClick($event)"
      />
    }
    <korviu-list [config]="productListConfig" #productList>
      <div *listFilters class="reward-filter-list">
        @for (filter of rewardFilters; track filter.key) {
          <button
            type="button"
            class="reward-filter-chip"
            [class.active]="activeRewardFilterKeys().has(filter.key)"
            [attr.aria-pressed]="activeRewardFilterKeys().has(filter.key)"
            (click)="toggleRewardFilter(filter.key)"
          >
            {{ filter.localizableName | translate }}
          </button>
        }
      </div>
    </korviu-list>
  </div>
</div>
